import { SAGE_LINKS, SAGE_TOOL_LABELS } from "@/lib/sageLinks";

// DIY-FIRST FOOTER — Founder's coffin nail (2026-08-11).
// Every Resilience product page carries this footer EXCEPT the ones flagged
// as reversal-direction (see DIY_FOOTER_SUPPRESSED in sageLinks.js). Copy is
// public, verbatim per the Founder's plain-ink ruling. Sage-link renders
// when the mapping is filled in `/lib/sageLinks.js`; otherwise a "Coming
// soon at Sage" pill sits where the click-through will go.
//
// 2026-08-22 · Founder plain-ink: the "A note from the Founder" block is
// suppressed on /products/the-founder ONLY — the note is circular there
// because the Founder IS the product. Every other product page keeps it.
export default function DIYFirstFooter({ slug, suppressed = false }) {
  if (suppressed) return null;
  const sageUrl = SAGE_LINKS[slug];
  const toolLabel = SAGE_TOOL_LABELS[slug] || "the equivalent tool at Sage";
  const hideFounderNote = slug === "the-founder";
  return (
    <section
      data-testid={`diy-footer-${slug}`}
      className="border-t border-[#27272a] bg-[#0a0a0b] py-16 px-6 sm:px-10"
    >
      <div className="max-w-[900px] mx-auto">
        <p className="font-mono text-[10px] uppercase tracking-[0.42em] text-[#ff5a00] mb-6">
          Do it yourself · Cheaper
        </p>
        <h2
          className="font-display uppercase leading-[1.05] text-[#ededed]"
          style={{ fontSize: "clamp(1.75rem, 3.4vw, 2.5rem)", letterSpacing: "-0.005em" }}
        >
          This is a service we offer that kills a boutique industry's prices.
        </h2>
        <p className="font-body text-lg text-[#a1a1aa] leading-relaxed mt-6">
          We don't want to do this for you. We want <em className="text-[#ededed] not-italic">you</em> to do it yourself,
          so the cheaper method is right here:
        </p>
        <div className="mt-6" data-testid={`diy-footer-cta-${slug}`}>
          {sageUrl ? (
            <a
              href={sageUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 font-mono text-[11px] uppercase tracking-[0.32em] bg-[#ff5a00] text-[#050505] px-6 py-3 hover:bg-[#ff8f00] transition-colors"
            >
              {toolLabel} →
            </a>
          ) : (
            <span className="inline-flex items-center gap-2 font-mono text-[10px] uppercase tracking-[0.32em] border border-[#ff5a00]/40 text-[#ff5a00]/80 px-5 py-3">
              {toolLabel} · link seating pending
            </span>
          )}
        </div>
        <p
          data-testid={`diy-footer-tell-${slug}`}
          className="mt-8 font-body text-lg text-[#ededed] leading-relaxed"
        >
          This is the exact product I'm about to use to do this for you.{" "}
          <span className="text-[#ff5a00]">Speak to it</span>, and don't pay{" "}
          <span className="text-[#ff5a00] font-mono not-italic">3x</span>{" "}
          more for it.
        </p>
        <div className="mt-16 pt-8 border-t border-white/5">
          {!hideFounderNote && (
            <>
              <p className="font-mono text-[10px] uppercase tracking-[0.42em] text-[#ff5a00] mb-4">
                The Founder's Note
              </p>
              <div
                data-testid={`founders-note-${slug}`}
                className="font-body text-lg text-[#ededed] leading-relaxed space-y-4"
              >
                <p>
                  AI has made any capable single user capable of collapsing cost
                  that once required a whole company. I am that user. This page
                  is that collapse.
                </p>
                <p>
                  The old industry above needed a room, a budget, and eighteen
                  months. I need a keyboard and a week. You are welcome to buy
                  the old way. You are more welcome to buy the new one — and
                  more welcome still to do it yourself with the tool linked
                  above. Any of those three routes ends the industry above.
                  I would rather it end than protect it.
                </p>
                <p className="italic text-[#a1a1aa]">
                  — The Founder
                </p>
              </div>
            </>
          )}
        </div>
      </div>
    </section>
  );
}
